import axios from "axios";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { auth } from "./firebase";
import {
  login,
  logout,
  setIsDeviceType,
  updateImageToken,
  updateNotification,
  selectIsIos,
} from "./features/userSlice";
import {
  getFirestoreDocData,
  snapshotFirestoreDocData,
} from "./apis/firestoreAction";
import { useDeviceType } from "./apis/util";
import { postRequest, getRequest } from "./apis/axiosAction";
import CircularProgress from "@material-ui/core/CircularProgress";
import { userLogging } from "./apis/userLog";
import { initializeExistingSejStores } from "./data/existingSejStores";
import { initializeEmployee } from "./data/employeeOfc";
import {
  isAdminCheckByElement,
  isDmCheckByElement,
  isKyoikusuishinShainkenshuDept,
  isTRDept,
  isZmCheckByElement,
  JOB_CATEGORY_CODE_OFC,
} from "./apis/privilege";
import {
  getInitTenpoCode,
  setInitTenpoCode,
  setFixedFlg,
  setFirstFlg,
} from "./components/Header/Header";
import {
  setOneVisionId,
  setLastOneVisionId,
} from "./components/OneVision/Register/OneVision";
import { setTenpoCheckId } from "./components/TenpoCheck/Register/TenpoCheck";
import { getTenpoFirestoreData } from "./components/TenpoCheck/Register/TenpoCheckTableDataOperation";
import { useLocation } from "react-router-dom";
import {
  generateKeyPairRsaOaep,
  exportPublicKey,
  arrayBufferToBase64,
  decryptRsaOaepAndConcatenate,
} from "./apis/cryptoUtils";

interface pathState {
  urlPath: string;
  state: string;
}

// URLのパス及びパラメータの調整を行う
const setUrlPath = (): pathState => {
  const url: URL = new URL(window.location.href);
  // URLパス対応(ログイン時とトップの場合はhomeへ進める)
  const path =
    url.pathname === "/login" || url.pathname === "/" ? "home" : url.pathname;
  const initial = "initial";

  // URLパラメータよりトークン項目を削除する
  const params: URLSearchParams = url.searchParams;
  params.delete("token");
  let parameter = "";
  params.forEach(function (value, key) {
    // ショートカット処理START
    // 店舗確認表 新規作成
    if (
      url.searchParams.toString().includes("tenpo-check-newversion") &&
      key === "tenpocode"
    ) {
      setFixedFlg(false);
      setInitTenpoCode(value);
      parameter = "";
    }
    // 店舗確認表 最新の店舗別の画面へ移動
    else if (
      url.searchParams.toString().includes("tenpo-check-latest") &&
      key === "tenpocode"
    ) {
      getTenpoFirestoreData(value).then((res: any) => {
        // 検索結果あり
        if (res) {
          //  ofcデータあり
          if (res.attribution.tenpo_check.ofc) {
            //  OFC登録データあり
            if (res.attribution.tenpo_check.ofc.last_time_id) {
              setInitTenpoCode(value);
              setTenpoCheckId(res.attribution.tenpo_check.ofc.last_time_id);
              setFixedFlg(true);
            }
            //  IDが空の場合（登録データなし、もしくはSOFCの可能性あり）
            else {
              setInitTenpoCode(value);
              setTenpoCheckId(res.attribution.tenpo_check.dm.last_time_id);
              setFixedFlg(true);
            }
          }
        }
      });
      parameter = "";
    }
    // ONEVISION 新規作成
    else if (
      url.searchParams.toString().includes("onevision-newversion") &&
      key === "tenpocode"
    ) {
      setFixedFlg(false);
      setInitTenpoCode(value);
      parameter = "";
    }
    // ONEVISION  最新の店舗別の画面へ移動
    else if (
      url.searchParams.toString().includes("onevision-latest") &&
      key === "tenpocode"
    ) {
      getTenpoFirestoreData(value).then((res: any) => {
        if (res) {
          if (res.attribution.one_vision.ofc) {
            setInitTenpoCode(value);
            setOneVisionId(res.attribution.one_vision.ofc.last_time_id);
            setLastOneVisionId("");
            setFixedFlg(true);
          } else {
            setInitTenpoCode(value);
            setOneVisionId(res.attribution.one_vision.last_time_id);
            setLastOneVisionId("");
            setFixedFlg(true);
          }
        }
      });
      parameter = "";
    }
    // ショートカット処理END
    else {
      parameter = key + "=" + value + "&";
    }
  });
  if (parameter !== "") {
    parameter = parameter.slice(0, -1);
    const val: pathState = {
      urlPath: path + "?" + parameter,
      state: initial,
    };
    return val;
  } else {
    const val: pathState = { urlPath: path, state: initial };
    return val;
  }
};

const startMenu: pathState = setUrlPath();

// 初期処理のハンドリングに用いる
let isFinishUserInfo: boolean = false;
let isTenpoMaster: boolean = false;

const App: React.FC = (props: any) => {
  const dispatch = useDispatch();
  const [isAnotherLoginLoading, setIsAnotherLoginLoading] =
    React.useState(false);
  // デバイスタイプの取得
  const isiOS = useSelector(selectIsIos);
  const search = useLocation().search;
  const query = new URLSearchParams(search);
  const tokenPatamertername = "token";
  const token = query.get(tokenPatamertername);
  // デバイス・OSの判定を呼び出し
  useDeviceType();
  useEffect(() => {
    // ショートカット処理 START
    const url: URL = new URL(window.location.href);
    // パラメーター付きのrootパスの場合
    if (url.pathname === "/" && url.searchParams.toString() !== "") {
      // 店舗確認表 新規作成
      if (url.searchParams.toString().includes("tenpo-check-newversion")) {
        startMenu.urlPath = "/tenpo-check";
      }
      // 店舗確認表 最新の店舗別の画面へ移動
      else if (url.searchParams.toString().includes("tenpo-check-latest")) {
        startMenu.urlPath = "/tenpo-check";
      }
      // ONEVISION 新規作成
      else if (url.searchParams.toString().includes("onevision-newversion")) {
        startMenu.urlPath = "/one-vision";
      }
      // ONEVISION  最新の店舗別の画面へ移動
      else if (url.searchParams.toString().includes("onevision-latest")) {
        startMenu.urlPath = "/one-vision";
      }
    }
    // ショートカット処理 END
    const unSub = auth.onAuthStateChanged(async (authUser) => {
      if (authUser) {
        // 初期処理
        initialOperation(authUser);
      } else {
        // firebase認証未
        if (token !== null) {
          // トークンがある場合はカスタム認証を実行
          try {
            await callCustomFirebaseAuthentication(token);
            // Firebase認証成功後は上記のauthUserブロックで処理される
          } catch (error) {
            console.error("カスタム認証エラー:", error);
            // 認証失敗時はデジタルツールに遷移
            window.location.href = process.env.REACT_APP_DIGITAL_TOOL!;
          }
        } else {
          // Firebase認証されず、かつデジタルツールから遷移せずにトークンがない場合はCookie経由で認証にトライする
          console.log("Cookie経由での認証を試行します");
          try {
            await callUserAuthAfterInitialLogin(true, false, false, false);
          } catch (error) {
            console.error("Cookie認証失敗:", error);
            if (process.env.REACT_APP_MODE === "develop") {
              // 開発モードのみログイン画面へ遷移可能とする
              props.history.push("login");
            } else {
              // Cookie認証も失敗した場合はデジタルツールに遷移
              window.location.href = process.env.REACT_APP_DIGITAL_TOOL!;
            }
          }
        }
      }
    });
    return () => {
      unSub();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, props.history]);

  // 初期処理
  const initialOperation = async (authUser: any): Promise<void> => {
    // ユーザーデータの取得
    setIsAnotherLoginLoading(true);
    userLogging("共通", "ログイン処理", "");
    //callCookieUpdate();
    dispatch(
      setIsDeviceType({
        deviceType: true,
        ios: true,
        iphone: true,
      })
    );

    // 初期処理の終了フロー
    const setTenpoMasterFirstOperationFinish = () => {
      isTenpoMaster = true;
      setFirstOperationFinish();
    };

    // 初期処理の終了フロー
    const setFirstOperationFinish = () => {
      let token: string = "";
      if (isFinishUserInfo && isTenpoMaster) {
        // GoogleCloudStorage取得用のトークンとメンテナンス通知の情報を取得する
        const funcUpdateAllUsers = (doc: any) => {
          token = doc.data().token;
          dispatch(
            updateImageToken({
              imageToken: token,
            })
          );
          dispatch(
            updateNotification({
              notification: doc.data().notification_contents,
            })
          );
        };
        // Firestoreの変更通知スナップショットのハンドリング
        snapshotFirestoreDocData(
          "application_info",
          "all_users",
          funcUpdateAllUsers
        );
        //  ウェイト表示解除
        setIsAnotherLoginLoading(false);
        //  メニュー表示
        props.history.push({
          pathname: startMenu.urlPath,
          state: startMenu.state,
        });
      }
    };

    // ユーザー情報APIの呼び出し
    postRequest(process.env.REACT_APP_COMMON_API!, {
      "api-name": "user-info",
    })
      .then((response: any) => {
        const json = JSON.parse(response.data.dataList[0]);
        dispatch(
          login({
            uid: authUser.uid,
            displayName: authUser.displayName,
            jobCategory: json.job_category,
            jobCategoryCodeOA: json.job_category_code_OA,
            departmentCodeOA: json.department_code_OA,
            mailAddress: json.mail_address,
            zoCode: json.zo_code,
            doCode: json.do_code,
            tenpoCode: json.tenpo_code,
            tenpoCodeSpecialList: json.tenpo_code_special_list
              ? json.tenpo_code_special_list
              : [],
            apps: json.apps,
          })
        );
        // 担当店以外のショートカットは無効
        if (
          !isAdminCheckByElement(
            json.job_category_code_OA,
            json.department_code_OA,
            json.mail_address
          ) &&
          !json.tenpo_code.includes(getInitTenpoCode())
        ) {
          setInitTenpoCode("");
        }
        // 社員情報取得
        if (
          isAdminCheckByElement(
            json.job_category_code_OA,
            json.department_code_OA,
            json.mail_address
          ) ||
          json.job_category === "gm" ||
          json.job_category === "ops" ||
          isZmCheckByElement(
            json.job_category_code_OA,
            json.department_code_OA
          ) ||
          isDmCheckByElement(json.job_category_code_OA) ||
          isTRDept(json.department_code_OA) ||
          isKyoikusuishinShainkenshuDept(json.department_code_OA)
        ) {
          //admin-group と zm は zocode の IN検索。
          //admin-group は zo‗code が空文字なので zocode in ("") で結果的に全件検索になる。
          let colname = "zocode";
          let invalue = json.zo_code;
          //空配列を回避
          if (Array.isArray(invalue) && invalue.length === 0) {
            invalue = [""];
          }
          //dm は docode の IN検索。;
          if (isDmCheckByElement(json.job_category_code_OA)) {
            colname = "docode";
            invalue = json.do_code;
          }
          let jobcodes = [JOB_CATEGORY_CODE_OFC];
          initializeEmployee(colname, invalue, jobcodes);
        }
        isFinishUserInfo = true;
        setFirstOperationFinish();
      })
      .catch((error) => {
        console.error("Error App initialOperation1: ", error);
        userLogging("共通", "社員情報取得エラー", JSON.stringify(error));
        setIsAnotherLoginLoading(false);
      });
    // FirestoreよりGoogleCloudStorageトークンを取得して店舗マスタを読み込む
    getFirestoreDocData("application_info", "all_users")
      .then((doc: any) => {
        initializeExistingSejStores(
          doc.token,
          setTenpoMasterFirstOperationFinish
        );
      })
      .catch((error) => {
        console.error("Error App initialOperation2: ", error);
        userLogging("共通", "店舗情報取得エラー", JSON.stringify(error));
      });
  };

  // Firebaseカスタム認証
  // const callCustomFirebaseAuthentication = async () => {
  //   const url: string = process.env.REACT_APP_API_URL_J11SPB22 + "auth/token";
  //   const response = await axios.get(url, {
  //     headers: {
  //       Authorization: "Bearer " + (await getFirebaseAuthToken(false)),
  //     },
  //   });
  //   // カスタム認証を行う
  //   firebase
  //     .auth()
  //     .signInWithCustomToken(response.data.dataList[0])
  //     .then(() => {
  //       console.log("custom");
  //     })
  //     .catch((e) => {
  //       console.log(e);
  //     });
  // };

  // Cookie経由認証
  // const callCookieAuthentication = async () => {
  //   const url: string = process.env.REACT_APP_API_URL_J11SPB22 + "auth/session-auth";
  //   return await axios.get(url);
  // };

  //TODO 呼ばれていないのでコメントアウト 2025/10/21
  // Cookie設定・更新
  // const callCookieUpdate = async () => {
  //   const url: string =
  //     process.env.REACT_APP_API_URL_J11SPB22 + "auth/session-update";
  //   return await getRequest(url);
  // };
  //TODO 不要なら削除

  /**
   * Firebaseカスタム認証及びユーザー情報取得
   * トークン情報の再利用を防ぐために公開鍵方式を用いる
   * @param token デジタルツールにて生成されたワンタイムトークン
   */
  const callCustomFirebaseAuthentication = async (
    token: string,
  ): Promise<void> => {
    try {
      const url: string =
        process.env.REACT_APP_DIGITAL_TOOL + "/auth/v1/users/user-auth";
      
      // Crypto Web APIでの公開鍵方式を用いて暗号化/複合化を行う
      const keyPair = await generateKeyPairRsaOaep();
      const publicKey = await exportPublicKey(keyPair);
      const publicKeyBase64 = arrayBufferToBase64(publicKey);
      const param = {
        user_token: token,
        public_key: publicKeyBase64,
      };
      const response = await postRequest(url, param, false, false);
      console.log("[DEBUG] user-auth raw response:", response);
      console.log("[DEBUG] user-auth response.data:", response?.data);
      if (!response || !response.data || !response.data.data) {
        console.log("[DEBUG] response.data.data が存在しません:", response?.data);
        throw new Error("認証APIからの応答が無効です");
      }
      
      const obj = JSON.parse(response.data.data);
      console.log("[DEBUG] user-auth parsed obj keys:", Object.keys(obj));
      console.log("[DEBUG] user-auth parsed obj:", obj);
      
      if (!obj["custom_token"]) {
        throw new Error("カスタムトークンが応答に含まれていません");
      }
      
      const storageToken = await decryptRsaOaepAndConcatenate(
        obj["storage_token"],
        keyPair,
      );
      const customToken = await decryptRsaOaepAndConcatenate(
        obj["custom_token"],
        keyPair,
      );
      
      // Firebaseカスタム認証を行う
      await auth.signInWithCustomToken(customToken);
    } catch (err) {
      console.error("カスタム認証エラー:", err);
      throw err; // エラーを再スローして呼び出し元で処理
    }
  };

  /**
   * 2回目ログイン以降Cookie処理及びアプリケーション情報やユーザー情報取得
   * 一部トークンでは情報の再利用を防ぐために公開鍵方式を用いる
   * @param token デジタルツールにて生成されたワンタイムトークン
   * @returns ユーザー情報が更新されたかどうか
   */
  const callUserAuthAfterInitialLogin = async (
    isCookieAuth: boolean = false,
    isCookieUpdate: boolean = false,
    isUserInfo: boolean = false,
    isStorageToken: boolean = false,
  ): Promise<boolean> => {
    try {
      const url: string =
        process.env.REACT_APP_DIGITAL_TOOL +
        "/auth/v1/users/user-auth-after-initial-login";
      // Crypto Web APIでの公開鍵方式を用いて暗号化/複合化を行う
      const keyPair = await generateKeyPairRsaOaep();
      const publicKey = await exportPublicKey(keyPair);
      const publicKeyBase64 = arrayBufferToBase64(publicKey);
      const param = {
        public_key: publicKeyBase64,
        is_cookie_auth: isCookieAuth,
        is_cookie_update: isCookieUpdate,
        is_user_info: isUserInfo,
        is_storage_token: isStorageToken,
      };
      const response = await postRequest(url, param, false);
      const obj = JSON.parse(response.data.data);
      
      if (isCookieAuth) {
        const customToken = await decryptRsaOaepAndConcatenate(
          obj["custom_token"],
          keyPair,
        );
        // Firebaseカスタム認証を行う
        // const cAuth = getAuth();
        await auth.signInWithCustomToken(customToken);
        console.log("signInWith Cookie Custom Token");
      }

      if (isStorageToken) {
        const storageToken = await decryptRsaOaepAndConcatenate(
          obj["storage_token"],
          keyPair,
        );
      }
      
      // Cookie認証でユーザー情報が更新された場合、ユーザー情報を再取得
      if (isCookieUpdate && isUserInfo) {
        await updateUserInfoFromAPI();
        return true; // ユーザー情報が更新された
      }
      
      return false; // ユーザー情報は更新されていない
      
    } catch (err) {
      console.error("Cookie認証エラー:", err);
      // firebase認証未
      if (process.env.REACT_APP_MODE === "develop") {
        // ローカルまたは開発環境ではログイン画面へ遷移する
        // navigate("/login");
        props.history.push("login");
      } else {
        // ログイン失敗時はデジタルツールに遷移する
        window.location.href = process.env.REACT_APP_DIGITAL_TOOL!;
      }
      throw err; // エラーを再スローして呼び出し元で処理
    }
  };

  // ユーザー情報更新関数
  const updateUserInfoFromAPI = async (): Promise<void> => {
    try {
      const response = await postRequest(
        process.env.REACT_APP_COMMON_API!,
        {
          "api-name": "user-info",
        },
        false,
      );
      
      // レスポンスデータの存在確認
      if (!response || !response.data || !response.data.dataList || response.data.dataList.length === 0) {
        console.error("ユーザー情報APIのレスポンスが空です:", response);
        throw new Error("ユーザー情報が取得できませんでした");
      }
      
      const json = JSON.parse(response.data.dataList[0]);
      // setUserInfo(json);
      dispatch(
        login({
          uid: json.mail_address,
          displayName: json.employee_name,
          jobCategory: json.job_category,
          jobCategoryCodeOA: json.job_category_code_OA,
          departmentCodeOA: json.department_code_OA,
          mailAddress: json.mail_address,
          zoCode: json.zo_code,
          doCode: json.do_code,
          tenpoCode: json.tenpo_code,
          employeeNo: json.employee_no,
          opviewSofcFlag: json.opview_sofc_flag,
          tenpoCodeSpecialList: json.tenpo_code_special_list,
          apps: json.apps,
        })
      );
    } catch (error) {
      console.error("ユーザー情報更新エラー:", error);
      throw error;
    }
  };

  return (
    <>
      {isAnotherLoginLoading ? (
        <div
          style={{
            justifyContent: "center",
            display: "flex",
          }}
        >
          <CircularProgress
            size={"40vh"}
            style={{
              color: "#ccc",
              top: "30vh",
              position: "absolute",
            }}
          />
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default App;
